import React from 'react';
import { useContext, useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SearchContext } from './SearchContainer';
import Svg from '../shared/Svg';
import ObjectIcon from '../shared/ObjectIcon';
import colors from '../../utils/colors';
import './ObjectSelector.scss';

const { capitalCase } = require('change-case');

export const ObjectSelector = () => {
  const [isOpen, toggleOpen] = useState(false);
  const wrapperRef = useRef(null);
  const context = useContext(SearchContext);
  const objects = useSelector((state) => state.mail.settings?.objectsAndDisplayFields);

  const options = objects?.map((object) => {
    const label = capitalCase(object.label);
    return { value: object.apiName, label };
  });

  const onchangeSelect = (selectedOption) => {
    const result = objects.find((obj) => obj.apiName === selectedOption);
    context.searchObjectUpdateCallback(result);
    toggleOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        toggleOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={'object-selector-container'} ref={wrapperRef}>
      <button type="button" className="object-selector-button" data-testid="save-location-search-object-selector" onClick={() => toggleOpen(!isOpen) }>
        <ObjectIcon objectApiName={context.searchObject?.apiName} className={'object-selector-itemImage'}/>
        <Svg
          className={'object-selector-button-icon'}
          data={'assets/chevrondown.svg'}
          fill={colors.grey}
        />
      </button>
      {isOpen &&
        <div className="object-selector-dropdown" data-testid="save-location-search-object-dropdown">
          <ul>
            {options.map((option) =>
              <li key={option.value}
                data-testid={`save-location-search-object-option-${option.value}`}
                onClick={() => onchangeSelect(option.value)}>
                <ObjectIcon
                  className={'object-selector-itemImage'}
                  objectApiName={option.value}
                />
                <p>{option.label}</p>
              </li>)}
          </ul>
        </div>
      }
    </div>
  );
};
